/**
 * iter90 — Wedfaces-style face-pointer overlay.
 *
 * Renders a small coloured rectangle + arrow for each detected face on top
 * of a photo thumbnail. The parent passes bboxes in ABSOLUTE pixel coords
 * (from the original decoded frame) along with img_w / img_h so this
 * component can scale them proportionally to whatever CSS size the
 * thumbnail is rendered at.
 *
 * Props:
 *   - bboxes: Array<[x1, y1, x2, y2]>
 *   - imgW, imgH: number — original image dimensions
 *   - highlightIndex?: number — one bbox to draw in a different colour
 *                                (used for the guest-avatar preview)
 */
const OVERLAY_COLORS = [
  "#f43f5e", // rose
  "#22c55e", // emerald
  "#eab308", // amber
  "#0ea5e9", // sky
  "#a855f7", // violet
  "#f97316", // orange
];

export default function FaceOverlay({ bboxes, imgW, imgH, highlightIndex = null }) {
  if (!bboxes || !bboxes.length || !imgW || !imgH) return null;
  return (
    <div
      className="absolute inset-0 pointer-events-none"
      data-testid="face-overlay"
    >
      {bboxes.map((b, i) => {
        if (!b || b.length < 4) return null;
        const [x1, y1, x2, y2] = b;
        const left = (x1 / imgW) * 100;
        const top = (y1 / imgH) * 100;
        const width = ((x2 - x1) / imgW) * 100;
        const height = ((y2 - y1) / imgH) * 100;
        const color = i === highlightIndex ? "#f43f5e" : OVERLAY_COLORS[i % OVERLAY_COLORS.length];
        return (
          <div
            key={i}
            className="absolute"
            style={{
              left: `${left}%`,
              top: `${top}%`,
              width: `${width}%`,
              height: `${height}%`,
              border: `2px solid ${color}`,
              borderRadius: 4,
              boxShadow: "0 0 0 1px rgba(0,0,0,0.35)",
            }}
            data-testid={`face-bbox-${i}`}
          >
            {/* Corner tag with face number */}
            <div
              className="absolute -top-4 left-0 text-[9px] font-bold px-1 rounded-sm"
              style={{ backgroundColor: color, color: "#fff" }}
            >
              {i + 1}
            </div>
          </div>
        );
      })}
    </div>
  );
}
